import { useState, useEffect } from 'react';
import { db } from './db';

interface DatabaseReadyState {
  isReady: boolean;
  error: Error | null;
}

/**
 * Hook that ensures the database is opened and all migrations have completed.
 * This prevents race conditions where components try to access data before
 * Dexie migrations (like Blob-to-string conversion) have run.
 */
export function useDatabaseReady(): DatabaseReadyState {
  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    db.open()
      .then(() => setIsReady(true))
      .catch((err: unknown) => {
        console.error('[DB] Failed to open database:', err);
        setError(err instanceof Error ? err : new Error(String(err)));
      });
  }, []);

  return { isReady, error };
}
